var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCalendario01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3_",
    d: "M28.5,5.8V2.3c0-1-0.8-1.7-1.7-1.7c-1,0-1.7,0.8-1.7,1.7v3.5H11V2.3c0-1-0.8-1.7-1.7-1.7S7.5,1.3,7.5,2.3 v3.5H5.8c-2.9,0-5.2,2.3-5.2,5.2l0,0v1.7h34.9V11c0-2.9-2.3-5.2-5.2-5.2H28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2_2_",
    d: "M2.1,33.9c1,1,2.3,1.5,3.7,1.5h24.4c2.9,0,5.2-2.3,5.2-5.2l0,0v-14H0.5v14C0.5,31.6,1.1,32.9,2.1,33.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendario01);
export default __webpack_public_path__ + "static/media/ico-calendario-01.9d55c4a26ec34ff23368802d16524796.svg";
export { ForwardRef as ReactComponent };